import React from 'react';
import includes from 'lodash/includes';
import { gettext } from '@eb/i18n';
import loadable from '@loadable/component';
import { FALLBACK_SUGGESTIONS } from '@eb/site-header';
import { InputField } from '@eb/eds-input-field';
import { Icon } from '@eb/eds-icon';
import { Button } from '@eb/eds-button';
import { MagnifyingGlassChunky } from '@eb/eds-iconography';

import './GlobalHeaderSearch.scss';

const SearchAutocompleteContainer = loadable(
    () => import('../../containers/SearchAutocompleteContainer'),
    {
        resolveComponent: (components) =>
            components.SearchAutocompleteContainer,
    },
);

import { EVENTS_TYPE, ALL_EVENTS_TYPE } from '../../constants';

export const getSearchInfo = (
    serverUrl,
    query,
    suggestions = FALLBACK_SUGGESTIONS,
) => {
    return {
        formAction: `${serverUrl}/d/`,
        label: gettext('Search'),
        query,
        suggestions,
    };
};

class GlobalHeaderSearchForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            searchQuery: props.initialSearchQuery,
            shouldFocusInput: false,
        };
    }

    _handleSearchSuggestionChange = (searchQuery) => {
        const { handleSearchSuggestionChange } = this.props;

        handleSearchSuggestionChange(searchQuery);
    };

    _handleApplySearchFilter = (searchFilter) => {
        const { searchQuery } = this.state;

        let newQuery = searchQuery;
        const { q } = searchFilter;

        if (q) {
            newQuery = q;
        }

        // when searching for 'events' or 'all events' input should be resetted
        if (includes([EVENTS_TYPE, ALL_EVENTS_TYPE], (q || '').toLowerCase())) {
            newQuery = '';
        }

        this.setState({
            searchQuery: newQuery,
        });
    };

    _handleSearchQueryChange = (searchQuery) => {
        this.setState({ searchQuery });

        if (this.props.onChange) {
            this.props.onChange(searchQuery);
        }
    };

    _handleSearchSuggestionChange = (searchQuery) => {
        const { handleSearchSuggestionChange } = this.props;

        handleSearchSuggestionChange(searchQuery);
    };

    _handleClearButtonClick = () => {
        this.setState({
            searchQuery: '',
            shouldFocusInput: true,
        });
    };

    _handleSearchFieldFocus = () => {
        this.setState({
            shouldFocusInput: true,
        });
    };

    _handleSearchFieldBlur = () => {
        this.setState({
            shouldFocusInput: false,
        });
    };

    render() {
        const {
            borderType,
            className,
            suggestions = {
                query: [],
                event: [],
                categories: [],
                events: [],
            },
            id,
            suffix,
            hasMinAsideSpacing,
            isHomePage,
            isBrowsePage,
        } = this.props;
        const { searchQuery, shouldFocusInput } = this.state;

        return (
            <div className={className}>
                <SearchAutocompleteContainer
                    parentId={id}
                    hasHistory={true}
                    suggestions={suggestions}
                    searchQuery={searchQuery}
                    // onChangeValue={this._handleChangeValue}
                    onSearchQueryChange={this._handleSearchQueryChange}
                    onSearchFilterChange={this._handleApplySearchFilter}
                    onClearButtonClick={this._handleClearButtonClick}
                    onFocus={this._handleSearchFieldFocus}
                    onBlur={this._handleSearchFieldBlur}
                    shouldFocusInput={shouldFocusInput}
                    borderType={borderType}
                    suffix={suffix}
                    hasMinAsideSpacing={hasMinAsideSpacing}
                    isHomePage={isHomePage}
                    isBrowsePage={isBrowsePage}
                />
            </div>
        );
    }
}

const GlobalHeaderSearch = ({
    searchInfo,
    id,
    onSelect,
    onSubmit,
    borderType,
    onChange,
    suffix,
    hasMinAsideSpacing,
    shouldRenderSearchTakeover,
    setRenderSearchTakeover,
    isHomePage,
    isBrowsePage,
    containerClassName = 'consumer-header__search',
    formClassName = 'consumer-header__search-autocomplete',
}) => {
    if (!searchInfo) {
        return null;
    }

    if (shouldRenderSearchTakeover) {
        return (
            <div
                className={containerClassName}
                data-spec="consumer-header-search"
            >
                <Button
                    onClick={() => setRenderSearchTakeover(true)}
                    style="none"
                    size="block"
                    __containerClassName="consumer-header__search--button"
                >
                    <InputField
                        disabled={true}
                        label={gettext('Search for events')}
                        id="header-event-search-button"
                        style="basic"
                        placeholder={gettext('Search events')}
                        prefix={
                            <Icon
                                color="ui-600"
                                type={<MagnifyingGlassChunky />}
                            />
                        }
                    />
                </Button>
            </div>
        );
    }

    // NOTE: the narrow search button below toggles the display of the narrow search dropdown.
    // That dropdown can also be hidden by "clicking away." However, clicking this button when
    // it's display should be considered a "click away" otherwise we'll have a case where the
    // dropdown will be hidden by "clicking away" and then show because we just clicked the
    // button to toggle it back on. So the "ignore-react-onclickoutside" class is a special
    // class that causes it not to be classified as a "click away".

    return (
        <div className={containerClassName} data-spec="consumer-header-search">
            <GlobalHeaderSearchForm
                searchInfo={searchInfo}
                id={id}
                className={formClassName}
                onChange={onChange}
                onSelect={onSelect}
                onSubmit={onSubmit}
                borderType={borderType}
                suffix={suffix}
                hasMinAsideSpacing={hasMinAsideSpacing}
                isHomePage={isHomePage}
                isBrowsePage={isBrowsePage}
            />
        </div>
    );
};

export default GlobalHeaderSearch;
